const ERROR_CODES = {
  notFoundVideo: 'E004', // 해당 영상이 삭제 되었거나 존재하지 않는 영상입니다
  notFoundItem: 'E100', // 존재하지 않는 항목입니다
  exclusiveAccessForPurchasers: 'E553', // 해당 라이브 또는 영상은 구매자 한정으로 시청할 수 있습니다
  notEnoughStarbeat: 'E600', // 스타비트 부족
  saleEndedUnavailable: 'E702', // 판매가 종료되어 구매할 수 없는 상품
  purchaseDuplicateRequest: 'E703', // 이미 구매한 상품(중복 구매 요청)
  purchaseLimitExceeded: 'E706', // 최대 구매 갯수 초과
  purchaseSoldOut: 'E707', // 품절
  purchaseGatewayFailed: 'E708', // PG사 오류 등 외부 요인으로 인한 오류
  invalidToken: 'E805', // 유효하지 않음 엑세스 토큰
  tokenExpired: 'E806', // 토큰 만료
  unauthorized: 'E809', // 권한 없음(토큰 없음)
  pendingPaymentInProgress: 'E812', // 현재 결제 pending인 상품이 있음
  productVersionUpdated: 'E900', // 상세 페이지 접속 상태 -> CMS 상품 정보 변경 -> 구매 요청 시 상품 version 변경으로 E900 떨어짐
  reportDuplicateRequest: 'E820', // 이미 신고되었습니다(중복 신고)
};

export default ERROR_CODES;
